'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/*\n* ink colors (with variations only for black and white)\n*/\n.dn-root {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n  height: 75px;\n  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.06);\n  font-size: calc(0.75 * 1rem);\n  line-height: 1.2 !important;\n  background-color: #ffffff;\n}\n.dn-root .container {\n  display: flex;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n  transition: all 0.5s ease 0.1s;\n  height: 100%;\n}\n@media (min-width: 768px) {\n  .dn-root .container {\n    max-width: 750px;\n  }\n}\n@media (min-width: 992px) {\n  .dn-root .container {\n    max-width: 970px;\n  }\n}\n@media (min-width: 1200px) {\n  .dn-root .container {\n    max-width: 1140px;\n  }\n}\n@media (max-width: 768px) {\n  .dn-root .container {\n    align-items: center;\n    height: inherit;\n  }\n}");
//# sourceMappingURL=DesktopNavbar.scss.js.map
